/**
 *
 */
import {roles} from './auth';

export const CONTRACT_STATUS = {
    /**
     *  A Contract has just been created.
     */
    CONTRACT_GENERATED: 'CONTRACT_GENERATED',

    /*
     * A The customer has signed the contract or the bam has signed on behalf
     */
    CUSTOMER_SIGNED: 'CUSTOMER_SIGNED',

    /**
     *  The contract has entered the system and is Review process
     */
    CONTRACT_REVIEW: 'CONTRACT_REVIEW',

    /*
     * A Grace representative has now signed and approved the contract
     */
    GK_SIGNED: 'GK_SIGNED',

    /**
     * Both user (GK & Customer) have signed the promissory notes and commitment letter contracts
     */
    AGREEMENT_SIGNED: 'AGREEMENT_SIGNED',

    /*
     * The Policies for the contract were generated.
     */
    POLICIES_CREATED: 'POLICIES_CREATED',

    /*
     * The Policy for the devices have been added.
     */
    POLICY_ADDED: 'POLICY_ADDED',

    /**
     * A physical/digital delivery slip has been sent to the user.
     */
    DELIVERY_SLIP_SENT: 'DELIVERY_SLIP_SENT',

    /**
     * Customer has signed a physical delivery slip
     */
    DELIVERY_SLIP_SIGNED: 'DELIVERY_SLIP_SIGNED', // At a physical delivery slip has been signed but not yet uploaded.

    /**
     * Delivery has been confirmed, at this state we have proof of delivery.
     */
    DELIVERED: 'DELIVERED',

    /**
     * Grace has issue payment for the contract.
     */
    GK_PAID: 'GK_PAID',

    /**
     * Sms has confirmed that the pay
     */
    PAYMENT_CONFIRMED: 'PAYMENT_CONFIRMED',

    /**
     * At this state all the requirements for the contracts have been met.
     */
    CONTRACT_STARTED: 'CONTRACT_STARTED',
};

export const contractColorsCodes = {
    Alert: 'var(--color-yellow-600)',
    Success: 'var(--color-green-700)',
    Neutral: 'var(--color-gray-600)',
};

/***
 *
 */
export const COMMITMENT_LETTER_STATUS = {
    GENERATED: 'GENERATED',
    CUSTOMER_SIGNED: 'CUSTOMER_SIGNED',
    GK_SIGNED: 'GK_SIGNED',
};
export const PROMISSORY_NOTE_STATUS = {
    GENERATED: 'GENERATED',
    CUSTOMER_SIGNED: 'CUSTOMER_SIGNED',
    GK_SIGNED: 'GK_SIGNED',
};

export const statusObjects = {

    CONTRACT_GENERATED: {
        color: contractColorsCodes.Alert,
        message: 'Awaiting Customer Signature',
        [roles.CUSTOMER_REP]: {
            color: contractColorsCodes.Neutral,
            message: 'Awaiting signature ',
        },
        [roles.BAM]: {
            color: contractColorsCodes.Neutral,
            message: ' Awaiting signature ',
        }
    },

    CUSTOMER_SIGNED: {
        color: contractColorsCodes.Alert,
        message: 'Awaiting Review',
        [roles.GK]: {
            color: contractColorsCodes.Alert,
            message: 'Awaiting your Approval ',
        },
        [roles.SMS]: {
            color: contractColorsCodes.Neutral,
            message: 'Awaiting GK Approval',
        },
        [roles.CUSTOMER_REP]: {
            color: contractColorsCodes.Neutral,
            message: 'Contract Submitted',
        },
        [roles.BAM]: {
            color: contractColorsCodes.Neutral,
            message: 'Contract Submitted ',
        }
    },

    CONTRACT_REVIEW: {
        color: contractColorsCodes.Alert,
        message: 'In Review',
    },

    /**
     *
     */
    GK_SIGNED: {
        color: contractColorsCodes.Success,
        message: 'Awaiting Agreements Signature',
        // [roles.GK]: {
        //     color: contractColorsCodes.Neutral,
        //     message: 'Awaiting SMS Fulfilment',
        // },
        // [roles.SMS]: {
        //     color: contractColorsCodes.Alert,
        //     message: 'Contract Approved - Awaiting Fulfilment',
        // },
        // [roles.CUSTOMER_REP]: {
        //     color: contractColorsCodes.Success,
        //     message: 'Contract Approved ',
        // },
        // [roles.BAM]: {
        //     color: contractColorsCodes.Success,
        //     message: 'Contract Approved ',
        // }

        [roles.CUSTOMER_REP]: {
            color: contractColorsCodes.Alert,
            message: ' Awaiting Promissory Note & Commitment Letter Signatures',
        },
        [roles.GK]: {
            color: contractColorsCodes.Alert,
            message: ' Awaiting Promissory Note & Commitment Letter Signatures',
        },
    },

    AGREEMENT_SIGNED: {
        color: contractColorsCodes.Alert,
        message: 'Awaiting Customer Signature',
        [roles.CUSTOMER_REP]: {
            color: contractColorsCodes.Alert,
            message: ' Awaiting Promissory Note & Commitment Letter Process Signatures',
        },
        [roles.BAM]: {
            color: contractColorsCodes.Alert,
            message: ' Awaiting Promissory Note & Commitment Letter Signatures',
        },

        [roles.GK]: {
            color: contractColorsCodes.Neutral,
            message: 'Awaiting SMS Fulfilment',
        },
        [roles.SMS]: {
            color: contractColorsCodes.Alert,
            message: 'Contract Approved - Awaiting Fulfilment',
        },
        [roles.CUSTOMER_REP]: {
            color: contractColorsCodes.Success,
            message: 'Contract Approved ',
        },
        [roles.BAM]: {
            color: contractColorsCodes.Success,
            message: 'Contract Approved ',
        }
    },

    POLICIES_CREATED: {
        color: contractColorsCodes.Success,
        message: 'Contract Approved - Policies Being Processed',
    },

    POLICY_ADDED: {
        color: contractColorsCodes.Success,
        message: 'Policies Added',
    },

    DELIVERY_SLIP_SENT: {
        color: contractColorsCodes.Success,
        message: 'Package Ready',
        [roles.GK]: {
            color: contractColorsCodes.Success,
            message: 'Package Ready for Customer ',
        },
        [roles.SMS]: {
            color: contractColorsCodes.Alert,
            message: 'Package Ready',
        },
        [roles.CUSTOMER_REP]: {
            color: contractColorsCodes.Success,
            message: 'Package Ready',
        },
        [roles.BAM]: {
            color: contractColorsCodes.Success,
            message: 'Package Ready',
        }
    },

    /**
     * Customer has signed a physical delivery slip
     */
    DELIVERY_SLIP_SIGNED: {
        color: contractColorsCodes.Success,
        message: 'Delivery Slip Signed',
        [roles.GK]: {
            color: contractColorsCodes.Success,
            message: 'Package Received',
        },
        [roles.SMS]: {
            color: contractColorsCodes.Alert,
            message: 'Devices Delivered - Upload Delivery Slip',
        },
        [roles.CUSTOMER_REP]: {
            color: contractColorsCodes.Success,
            message: 'Package Received',
        },
        [roles.BAM]: {
            color: contractColorsCodes.Success,
            message: 'Package Received',
        }
    },

    DELIVERED: {
        color: contractColorsCodes.Success,
        message: 'Devices Delivered',
        [roles.GK]: {
            color: contractColorsCodes.Alert,
            message: 'Payment Due',
        },
        [roles.SMS]: {
            color: contractColorsCodes.Success,
            message: 'Devices Delivered',
        },
        [roles.CUSTOMER_REP]: {
            color: contractColorsCodes.Success,
            message: 'Contract Active ',
        },
        [roles.BAM]: {
            color: contractColorsCodes.Success,
            message: 'Contract Active - Devices Delivered',
        }
    },

    GK_PAID: {
        color: contractColorsCodes.Alert,
        message: 'Payment Issued',
        [roles.CUSTOMER_REP]: {
            color: contractColorsCodes.Success,
            message: 'Active',
        },
        [roles.GK]: {
            color: contractColorsCodes.Neutral,
            message: 'Awaiting Payment Confirmation',
        },
        [roles.SMS]: {
            color: contractColorsCodes.Success,
            message: 'Payment Submitted. Please Confirm ',
        },
        [roles.CUSTOMER_REP]: {
            color: contractColorsCodes.Success,
            message: 'Contract Active',
        },
        [roles.BAM]: {
            color: contractColorsCodes.Success,
            message: 'Contract Active',
        }
    },

    PAYMENT_CONFIRMED: {
        color: contractColorsCodes.Alert,
        message: 'Contract Paid',
        [roles.CUSTOMER_REP]: {
            color: contractColorsCodes.Success,
            message: 'Contract Active',
        },
        [roles.GK]: {
            color: contractColorsCodes.Success,
            message: 'Payment Confirmed',
        },
        [roles.SMS]: {
            color: contractColorsCodes.Success,
            message: 'Payment Received',
        },
        [roles.BAM]: {
            color: contractColorsCodes.Success,
            message: 'Contract Active',
        }
    },

    CONTRACT_STARTED: {
        color: contractColorsCodes.Alert,
        message: 'Contract Started',
    },

};

export const CONTRACT_KEYS = {
    CONTRACT: 'finance_lease_signed',
    PROMISSORY_NOTE: 'promissory_note',
    COMMITMENT_LETTER: 'commitment_letter',
};
